/* Fonts */
.slide {
  font-size: 4cqh;
  line-height: 1.28581;
  .slide-title {
    font-weight: bold;
    font-size: 1.4em;
  }
  .slide-sidebar-title {
    font-weight: bold;
    font-size: 1em;
  }
  .slide-next-slide {
    font-weight: bold;
  }
  .slide-navigation ul {
    font-size: 0.8em;
  }
}
.slide-type-program-title .slide-title {
  font-size: 2.4em;
}

.slide {
  /* Variables */
  --separator-color: black;
  --separator-size: 1px;
  --row-gap: 3.5cqh;

  height: 100cqh;
  width: 100cqw;
  text-align: center;
  display: grid;
  padding-block: 5cqh;
  row-gap: var(--row-gap);
  grid-template:
    "title separator sidebar-title" auto
    "content separator sidebar" 1fr
    / 2fr var(--separator-size) var(--sidebar-width, 0);
  --sidebar-width: 0;

  &.invisible {
    position: absolute;
    top: -100cqh;
    left: -100cqw;
  }

  &:has(.slide-sidebar-content) {
    --sidebar-width: 1fr;

    &:after { /* Vertical separator between content and nav */
      content: '';
      grid-area: separator;
      background: var(--separator-color);
    }
  }

  & > * {
    min-height: 0;
    min-width: 0;
  }

  .slide-title {
    grid-area: title;
  }
  .slide-content {
    display: flex;
    flex-direction: column;
    grid-area: content;
    padding-inline: 1cqw;
  }
  .slide-main-content {
    flex-grow: 1;
  }
  .slide-program-footer {
    margin-top: var(--row-gap);
    flex-shrink: 0;
  }
  .slide-next-slide {
    --gap: var(--row-gap);
    margin-top: var(--gap);
    padding-top: var(--gap);
    border-top: var(--separator-size) solid var(--separator-color);
    text-align: center;
    margin-inline: 1.5em;
  }
  .slide-sidebar-title {
    grid-area: sidebar-title;
  }
  .slide-sidebar-content {
    grid-area: sidebar;
    display: flex;
    flex-direction: column;
    padding-inline: 1cqw;
  }
  .slide-navigation{
    flex-grow: 1;
  }
  .slide-program-footer {
    grid-area: footer;
  }

  .slide-navigation-list {
    text-align: center;
    li.current {
      font-weight: bold;
    }
    li:not(.current) {
      opacity: 0.8;
      scale: 0.9;
    }
  }
}
